require('bootstrap/dist/css/bootstrap.min.css');
require('./static/global.css');
require('./static/fontawesome/css/fontawesome.min.css');
// regular.min.css removed: no fa-regular icons are used anywhere on the site
require('./static/fontawesome/css/solid.min.css');

const { analytics } = require('./src/analytics');
const {
  getParameterByName,
  getPathName,
  getDeviceType,
} = require('./src/common/utils');
const {
  UTM_CAMPAIGN_STORAGE_KEY,
  UTM_SOURCE_STORAGE_KEY,
  UTM_CONTENT_STORAGE_KEY,
  UTM_MEDIUM_STORAGE_KEY,
  GCLID_STORAGE_KEY,
  GATSBY_AUTH0_COOKIE_DOMAIN,
} = require('./src/constants');

const getPageName = () => {
  const path = getPathName();
  const [, name, title] = path.split('/');
  return {
    name: name || 'home',
    title,
  };
};

const getUtmSource = () => {
  // Save utm_source in localStorage if its on the url
  const source = getParameterByName('utm_source');
  if (source) {
    return source;
  }

  // Save page name in localStorage if there is no utm_source in localStorage
  const { name } = getPageName();
  if (!localStorage.getItem(UTM_SOURCE_STORAGE_KEY)) {
    return name;
  }

  return undefined;
};

const getUtmCampaign = () => {
  // Save utm_campaign in localStorage if its on the url
  const campaign = getParameterByName('utm_campaign');
  if (campaign) {
    return campaign;
  }

  // Save page title (for blogs) in localStorage if there is no utm_campaign in localStorage
  const { title } = getPageName();
  if (!localStorage.getItem(UTM_CAMPAIGN_STORAGE_KEY) && title) {
    return title;
  }

  return undefined;
};

const getUtmMedium = () => {
  const medium = getParameterByName(UTM_MEDIUM_STORAGE_KEY);
  if (medium) {
    return medium;
  }

  return undefined;
};

const getUtmContent = () => {
  const content = getParameterByName(UTM_CONTENT_STORAGE_KEY);
  if (content) {
    return content;
  }

  return undefined;
};

const getGclid = () => {
  const gclid = getParameterByName('gclid');
  if (gclid) {
    return gclid;
  }
  return undefined;
};

exports.onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    await require(`intersection-observer`);
  }
};

exports.onInitialClientRender = () => {
  analytics.track('Marketing-Landed', {
    category: 'Marketing',
    deviceType: getDeviceType(),
  });

  // Set utm_source and utm_campaign in localStorage
  // to save along with user details on sign up
  const source = getUtmSource();
  if (source) {
    localStorage.setItem(UTM_SOURCE_STORAGE_KEY, source);
  }

  const campaign = getUtmCampaign();
  if (campaign) {
    localStorage.setItem(UTM_CAMPAIGN_STORAGE_KEY, campaign);
  }

  const medium = getUtmMedium();
  if (medium) {
    localStorage.setItem(UTM_MEDIUM_STORAGE_KEY, medium);
  }

  const content = getUtmContent();
  if (content) {
    localStorage.setItem(UTM_CONTENT_STORAGE_KEY, content);
  }

  const gclid = getGclid();
  if (gclid) {
    localStorage.setItem(GCLID_STORAGE_KEY, gclid);
  }
  // setTimeout(function() {
  //   var iframe = document.createElement('iframe');
  //   iframe.style.width = '1px';
  //   iframe.style.height = '1px';
  //   iframe.style.border = 'none';
  //   iframe.src = GATSBY_AUTH0_COOKIE_DOMAIN;
  //   document.body.appendChild(iframe);
  //   console.log('IFRAME ADDED...');
  // }, 1000);
};

// Always scroll to top on route change.
// `html { scroll-behavior: smooth }` (leaked globally from
// ContentPillar.module.scss) turns Gatsby's default [0, 0] reset into an
// animated scroll that the new page's render can cancel mid-flight, leaving
// the page stuck partway down (e.g. footer link to /insurance-index).
// Scroll instantly ourselves and return false so Gatsby doesn't re-scroll.
exports.shouldUpdateScroll = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  return false;
};

exports.onRouteUpdate = () => {
  analytics.page();

  const source = getParameterByName('utm_source');
  if (source) {
    analytics.track(`Source-${source}`, {
      category: 'Marketing',
    });
  }

  // Check utm campaign, and log event accordingly
  const campaign = getParameterByName('utm_campaign');
  const utm_content = getParameterByName('utm_content');

  if (campaign) {
    analytics.track(`Campaign-${campaign}`, {
      category: 'Marketing',
      utm_content,
    });

    if (utm_content) {
      analytics.track(`Content-${utm_content}`, {
        category: 'Marketing',
      });
    }
  }
};
